import { useEffect, useRef } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { motion } from 'motion/react'
import { Col, Container, Row } from 'react-bootstrap'
import animationVariants from '../lib/animationVariants'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectCoverflow } from 'swiper/modules'
import 'swiper/css/bundle'

export default function FamilyAtWork ({ data }) {
  const location = useLocation()
  const { direction } = location.state || {}
  const swiperRef = useRef()
  const [searchParams] = useSearchParams()

  function handleCarouselNav (e, dir) {
    const swiper = swiperRef.current.swiper
    if (dir === 'prev') {
      swiper.slidePrev()
    } else if (dir === 'next') {
      swiper.slideNext()
    }
  }

  useEffect(() => {
    const searchId = searchParams.get('id')
    const swiper = swiperRef.current.swiper
    if (searchId) {
      const index = data.items.findIndex((el) => el.id === searchId)
      swiper.slideTo(index)
    }
  }, [searchParams, data.items])

  useEffect(() => {
    if (location.state) {
      location.state.background = '#1F1F1F'
    } else {
      location.state = {
        background: '#1F1F1F'
      }
    }
  }, [location])

  return (
    <motion.div className='w-100 h-100' variants={animationVariants[direction]} initial='hidden' animate='visible' exit='exit'>
      <Container fluid className='w-100 h-100'>
        <Row as='section' id='family-at-work' className='h-100'>
          <Col>
            <Row>
              <Col>
                <p className='intro-text'>Over the years, the extended Ames family has helped to build on our successes and overcome our challenges. With heartfelt appreciation, we acknowledge family members who have contributed their skills and talents, both past and present, for the betterment of Ames Construction.</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <Swiper
                  ref={swiperRef}
                  className='family-at-work-carousel w-100 pt-5'
                  modules={[EffectCoverflow]}
                  effect='coverflow'
                  grabCursor
                  centeredSlides
                  slidesPerView='auto'
                  coverflowEffect={{
                    rotate: 2,
                    stretch: 0,
                    scale: 0.95,
                    depth: 50,
                    modifier: 1,
                    slideShadows: false
                  }}
                  slideToClickedSlide
                >
                  {data.items.map((item, i) => (
                    <SwiperSlide id={item.id} key={`swiper-slide-${i}-${item.id}`}>
                      {item.img ? <img src={item.img} alt='' className='img-fluid' /> : <img src='/images/placeholder.png' alt='' className='img-fluid' />}

                      {item.label && (
                        <div className='caption text-center pt-2'>
                          <span className='d-block'>{item.name}</span>
                          <span className='d-block'>{item.label}</span>
                        </div>
                      )}
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>
            </Row>
            <Row>
              <Col className='pb-5'>
                <div className='d-flex justify-content-center align-items-center pt-4'>
                  <div className='flipster-button-previous' onClick={event => handleCarouselNav(event, 'prev')}>
                    <img src='/images/chevron-left.png' alt='' />
                  </div>
                  <div className='flipster-button-next' onClick={event => handleCarouselNav(event, 'next')}>
                    <img src='/images/chevron-right.png' alt='' />
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </motion.div>
  )
}
